export const ADD_APP_TRANSACTION = 'ADD_APP_TRANSACTION';

/* Auth */
export const SIGN_IN = 'auth/SIGN_IN';
export const RESEND_PASSWORD = 'auth/RESEND_PASSWORD';
export const CHECK_REGISTRATION = 'auth/CHECK_REGISTRATION';
export const SEND_FINISH_REGISTRATION_EMAIL = 'auth/SEND_FINISH_REGISTRATION_EMAIL;';

/* Log In | Log Out */
export const SET_LOGIN_STATUS = 'app/SET_LOGIN_STATUS';
export const SET_APP_CURRENCY = 'app/SET_APP_CURRENCY';
export const SET_APP_LANGUAGE = 'app/SET_APP_LANGUAGE';
export const LOG_IN = 'app/LOG_IN';
export const LOG_OUT = 'app/LOG_OUT';

/* User */
export const GET_USER = 'user/GET_USER';
export const SET_USER = 'user/SET_USER';
export const UPDATE_USER_DATA = 'user/UPDATE_USER_DATA';
export const UPDATE_USER_AGREEMENTS = 'user/UPDATE_USER_AGREEMENTS';

/* FAQs */
export const GET_FAQ_CATEGORIES = 'faq/GET_FAQ_CATEGORIES';
export const SET_FAQ_CATEGORIES = 'faq/SET_FAQ_CATEGORIES';
export const GET_FAQ_QUESTIONS = 'faq/GET_FAQ_QUESTIONS';
export const SET_FAQ_QUESTIONS = 'faq/SET_FAQ_QUESTIONS';
export const GET_MOST_SEARCHED_FAQ = 'faq/GET_MOST_SEARCHED_FAQ';
export const SET_MOST_SEARCHED_FAQ = 'faq/SET_MOST_SEARCHED_FAQ';
export const GET_SEARCHED_FAQ = 'faq/GET_SEARCHED_FAQ';
export const SET_SEARCHED_FAQ = 'faq/SET_SEARCHED_FAQ';
export const GET_FAQ_ANSWER = 'faq/GET_FAQ_ANSWER';
export const SET_FAQ_ANSWER = 'faq/SET_FAQ_ANSWER';

/* Borrower dashboard  */
export const GET_BORROWER_DASHBOARD_DATA = 'dashboard/GET_BORROWER_DASHBOARD_DATA';
export const SET_BORROWER_DASHBOARD_DATA = 'dashboard/SET_BORROWER_DASHBOARD_DATA';

/* Investor dashboard  */
export const GET_INVESTOR_DASHBOARD_DATA = 'dashboard/GET_INVESTOR_DASHBOARD_DATA';
export const SET_INVESTOR_DASHBOARD_DATA = 'dashboard/SET_INVESTOR_DASHBOARD_DATA';

export const GET_INVESTOR_INVESTMENTS = 'investments/GET_INVESTOR_INVESTMENTS';
export const SET_INVESTOR_INVESTMENTS = 'investments/SET_INVESTOR_INVESTMENTS';

export const GET_INVESTMENTS_FOR_SALE = 'investments/GET_INVESTMENTS_FOR_SALE';
export const SET_INVESTMENTS_FOR_SALE = 'investments/SET_INVESTMENTS_FOR_SALE';

export const POST_INVESTMENTS_FOR_SALE = 'investments/POST_INVESTMENTS_FOR_SALE';

export const GET_INVESTOR_OFFERS = 'investments/GET_INVESTOR_OFFERS';
export const GET_INVESTOR_OFFERS_ERROR = 'investments/GET_INVESTOR_OFFERS_ERROR';
export const SET_INVESTOR_OFFERS = 'investments/SET_INVESTOR_OFFERS';

export const GET_INVESTOR_OFFERS_COUNT = 'investments/GET_INVESTOR_OFFERS_COUNT';
export const GET_INVESTOR_OFFERS_COUNT_ERROR = 'investments/GET_INVESTOR_OFFERS_COUNT_ERROR';
export const SET_INVESTOR_OFFERS_COUNT = 'investments/SET_INVESTOR_OFFERS_COUNT';

export const GET_INVESTOR_INVESTMENT_DETAIL = 'investments/GET_INVESTOR_INVESTMENT_DETAIL';
export const SET_INVESTOR_INVESTMENT_DETAIL = 'investments/SET_INVESTOR_INVESTMENT_DETAIL';
export const SELL_INVESTOR_INVESTMENT_TO_GUARANTEE_FUND =
  'investments/SELL_INVESTOR_INVESTMENT_TO_GUARANTEE_FUND';

export const GET_INVESTOR_INVESTMENT_INSTRUCTION =
  'investments/GET_INVESTOR_INVESTMENT_INSTRUCTION';
export const SET_INVESTOR_INVESTMENT_INSTRUCTION =
  'investments/SET_INVESTOR_INVESTMENT_INSTRUCTION';
export const SEND_INVESTOR_INVESTMENT_INSTRUCTION =
  'investments/SEND_INVESTOR_INVESTMENT_INSTRUCTION';

export const GET_DEPOSIT_QR_CODE_STRING = 'deposits/GET_DEPOSIT_QR_CODE_STRING';
export const GET_DEPOSIT_QR_CODE_STRING_ERROR = 'deposits/GET_DEPOSIT_QR_CODE_STRING_ERROR';
export const SET_DEPOSIT_QR_CODE_STRING = 'deposits/SET_DEPOSIT_QR_CODE_STRING';
export const RESET_DEPOSIT_QR_CODE_STRING = 'deposits/RESET_DEPOSIT_QR_CODE_STRING';

export const CREATE_INVESTOR_INVESTMENT_OFFER = 'investments/CREATE_INVESTOR_INVESTMENT_OFFER';
export const CANCEL_INVESTOR_INVESTMENT_OFFER = 'investments/CANCEL_INVESTOR_INVESTMENT_OFFER';

export const GET_INVESTOR_SECONDARY_MARKET = 'investments/GET_INVESTOR_SECONDARY_MARKET';
export const SET_INVESTOR_SECONDARY_MARKET = 'investments/SET_INVESTOR_SECONDARY_MARKET';

export const GET_INVESTOR_BIDDINGS = 'investments/GET_INVESTOR_BIDDINGS';
export const SET_INVESTOR_BIDDINGS = 'investments/SET_INVESTOR_BIDDINGS';

export const ACCEPT_BIDDING = 'investments/ACCEPT_BIDDING';
export const DECLINE_BIDDING = 'investments/DECLINE_BIDDING';

export const BUY_OFFER_FROM_SECONDARY_MARKET = 'investments/BUY_OFFER_FROM_SECONDARY_MARKET';
export const BID_OFFER_FROM_SECONDARY_MARKET = 'investments/BID_OFFER_FROM_SECONDARY_MARKET';

export const TRANSFER_CLAIM = 'investments/TRANSFER_CLAIM';

export const SEND_INVESTOR_INSTRUCTION = 'instruction/SEND_INVESTOR_INSTRUCTION';

/* Onboarding Borrower */
export const SEND_PERSONAL_INFORMATION_PROCESSING_AGREES =
  'onboarding/SEND_PERSONAL_INFORMATION_PROCESSING_AGREES';

export const GET_BORROWER_ONBOARDING_STEP = 'onboarding/GET_BORROWER_ONBOARDING_STEP';
export const SET_BORROWER_ONBOARDING_STEP = 'onboarding/SET_BORROWER_ONBOARDING_STEP';
export const SEND_BORROWER_ONBOARDING_STEP = 'onboarding/SEND_BORROWER_ONBOARDING_STEP';
export const SEND_BORROWER_ONBOARDING_DOCUMENTS = 'onboarding/SEND_BORROWER_ONBOARDING_DOCUMENTS';

/* Onboarding Investor */
export const GET_INVESTOR_ONBOARDING_STEP = 'onboarding/GET_INVESTOR_ONBOARDING_STEP';
export const SET_INVESTOR_ONBOARDING_STEP = 'onboarding/SET_INVESTOR_ONBOARDING_STEP';
export const SEND_INVESTOR_ONBOARDING_STEP = 'onboarding/SEND_INVESTOR_ONBOARDING_STEP';
export const SEND_INVESTOR_ONBOARDING_IDENTITY = 'onboarding/SEND_INVESTOR_ONBOARDING_IDENTITY';
export const SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS =
  'onboarding/SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS';

export const GET_INVESTOR_DOCUMENT_TYPES = 'onboarding/GET_INVESTOR_DOCUMENT_TYPES';
export const GET_DEBTOR_DOCUMENT_TYPES = 'onboarding/GET_DEBTOR_DOCUMENT_TYPES';
export const SET_ONBOARDING_DOCUMENT_TYPES = 'onboarding/SET_ONBOARDING_DOCUMENT_TYPES';

/* Requests */
export const GET_REQUEST_TEMPLATE = 'requests/GET_REQUEST_TEMPLATE';
export const CREATE_REQUEST = 'requests/CREATE_REQUEST';

/* Estimated earnings graph */
export const GET_ESTIMATED_EARNINGS_GRAPH_DATA = 'estimates/GET_ESTIMATED_EARNINGS_GRAPH_DATA';
export const SET_ESTIMATED_EARNINGS_GRAPH_DATA = 'estimates/SET_ESTIMATED_EARNINGS_GRAPH_DATA';

/* Onboarding SMS Global */
export const SEND_SMS = 'onboarding/SEND_SMS';
export const SEND_PUBLIC_SMS = 'onboarding/SEND_PUBLIC_SMS';
export const VERIFY_PHONE_NUMBER = 'onboarding/VERIFY_PHONE_NUMBER';
export const VERIFY_PHONE_NUMBER_SUCCESS = 'onboarding/VERIFY_PHONE_NUMBER_SUCCESS';
export const VERIFY_PHONE_NUMBER_ERROR = 'onboarding/VERIFY_PHONE_NUMBER_ERROR';

/* Mailbox */
export const GET_MAILBOX_EMAILS = 'mailbox/GET_MAILBOX_EMAILS';
export const GET_MAILBOX_EMAILS_ERROR = 'mailbox/GET_MAILBOX_EMAILS_ERROR';
export const SET_MAILBOX_EMAILS = 'mailbox/SET_MAILBOX_EMAILS';

export const GET_MAILBOX_DOCUMENTS = 'mailbox/GET_MAILBOX_DOCUMENTS';
export const GET_MAILBOX_DOCUMENTS_ERROR = 'mailbox/GET_MAILBOX_DOCUMENTS_ERROR';
export const SET_MAILBOX_DOCUMENTS = 'mailbox/SET_MAILBOX_DOCUMENTS';

export const GET_MAILBOX_REQUESTS = 'mailbox/GET_MAILBOX_REQUESTS';
export const GET_MAILBOX_REQUESTS_ERROR = 'mailbox/GET_MAILBOX_REQUESTS_ERROR';
export const SET_MAILBOX_REQUESTS = 'mailbox/SET_MAILBOX_REQUESTS';

export const GET_MAILBOX_LETTERS = 'mailbox/GET_MAILBOX_LETTERS';
export const GET_MAILBOX_LETTERS_ERROR = 'mailbox/GET_MAILBOX_LETTERS_ERROR';
export const SET_MAILBOX_LETTERS = 'mailbox/SET_MAILBOX_LETTERS';

export const GET_MAILBOX_SMS = 'mailbox/GET_MAILBOX_SMS';
export const GET_MAILBOX_SMS_ERROR = 'mailbox/GET_MAILBOX_SMS_ERROR';
export const SET_MAILBOX_SMS = 'mailbox/SET_MAILBOX_SMS';

export const GET_MAILBOX_ALL = 'mailbox/GET_MAILBOX_ALL';
export const GET_MAILBOX_ALL_ERROR = 'mailbox/GET_MAILBOX_ALL_ERROR';
export const SET_MAILBOX_ALL = 'mailbox/SET_MAILBOX_ALL';

export const GET_MAILBOX_REPORTS = 'mailbox/GET_MAILBOX_REPORTS';
export const GET_MAILBOX_REPORTS_ERROR = 'mailbox/GET_MAILBOX_REPORTS_ERROR';
export const SET_MAILBOX_REPORTS = 'mailbox/SET_MAILBOX_REPORTS';

export const SET_MAILBOX_REPORTS_SUBSCRIPTION = 'mailbox/SET_MAILBOX_REPORTS_SUBSCRIPTION';
export const SET_MAILBOX_REPORTS_SUBSCRIPTION_ERROR =
  'mailbox/SET_MAILBOX_REPORTS_SUBSCRIPTION_ERROR';
export const SET_MAILBOX_REPORTS_SUBSCRIPTION_USER =
  'mailbox/SET_MAILBOX_REPORTS_SUBSCRIPTION_USER';

export const SET_GLOBAL_SERVER_ERROR_VISIBILITY = 'app/SET_GLOBAL_SERVER_ERROR_VISIBILITY';

/* Resources */
export const GET_RESOURCES_REQUEST = 'investments/GET_RESOURCES_REQUEST';
export const GET_RESOURCES_SUCCESS = 'investments/GET_RESOURCES_SUCCESS';
export const GET_RESOURCES_ERROR = 'investments/GET_RESOURCES_ERROR';
